import * as React from 'react';
import { LeftSideMenu } from '@ui/components';
import { metaSelectors } from '@ui/store/meta';
import { connect } from 'react-redux';
import { StoreState } from '@ui/store/rootReducer';
import CreateManagerForm from '../components/CreateManagerForm';
import EditManagerForm from '../components/EditManagerForm';
import * as actions from '../services/actions';
import { managersSelectors } from '..';

interface StateToProps {
  countries?: any[];
  regions?: any[];
  editManager: any;
}

interface DispatchToProps {
  onCreateManager?: (manager: any) => void;
  onEditManager?: (manager: any) => void;
  removeEditManager: () => void;
}

type Props = StateToProps & DispatchToProps;

class ManagersLeftSide extends React.PureComponent<Props> {
  state = {
    country: '',
  };

  handleCreateManager = () => {
    const { onCreateManager = () => null } = this.props;
    const { form } = this.formRef.props;

    form.validateFields((err: any, values: any) => {
      if (err) {
        return;
      }

      onCreateManager(values);
    });
  };

  handleEditManager = () => {
    const { onEditManager = () => null, editManager } = this.props;
    const { form } = this.formRef.props;

    form.validateFields((err: any, values: any) => {
      if (err) {
        return;
      }

      onEditManager({ ...editManager, ...values });
    });
  };

  handleChangeValues = (changedValues: any) => {
    if (changedValues.country) {
      this.setCountry(changedValues.country);
      const { form } = this.formRef.props;

      form.setFieldsValue({ regions: [] });
    }
  };

  setCountry = (country: any) => {
    this.setState({ country });
  };

  saveFormRef = (formRef: any) => {
    this.formRef = formRef;
  };

  private formRef: any;

  render() {
    const { countries = [], regions = [], editManager, removeEditManager } = this.props;

    const { country: countryState } = this.state;

    const hasEditManager = !!editManager;

    const country = !countryState && hasEditManager ? editManager.country.id.toString() : countryState;

    const regionsList = regions.filter((region: any) => region.country.id.toString() === country);

    console.log(country, regionsList, editManager);

    return (
      <LeftSideMenu topPanel={hasEditManager ? <span>{editManager.login}</span> : <span>Новый менеджер</span>}>
        {hasEditManager ? (
          <EditManagerForm
            wrappedComponentRef={this.saveFormRef}
            // @ts-ignore
            countries={countries}
            regions={regionsList}
            onCreate={this.handleEditManager}
            onChangeValues={this.handleChangeValues}
            removeEditManager={removeEditManager}
            manager={editManager}
          />
        ) : (
          <CreateManagerForm
            wrappedComponentRef={this.saveFormRef}
            // @ts-ignore
            countries={countries}
            regions={regionsList}
            hasCountry={!!country}
            onCreate={this.handleCreateManager}
            onChangeValues={this.handleChangeValues}
          />
        )}
      </LeftSideMenu>
    );
  }
}

const mapStateToProps = (state: StoreState): StateToProps => ({
  countries: metaSelectors.getCountries(state),
  regions: metaSelectors.getRegions(state),
  editManager: managersSelectors.getEditManageer(state),
});

const mapDispatchToProps = {
  onCreateManager: actions.createManagerRequested,
  onEditManager: actions.editManagerRequested,
  removeEditManager: actions.removeEditManager,
};

export default connect(mapStateToProps, mapDispatchToProps)(ManagersLeftSide);



// WEBPACK FOOTER //
// ./src/scenes/Managers/containers/ManagersLeftSide.tsx